import { ArrowUpRight } from "lucide-react";

function eventDate(date, lang) {
  return new Date(`${date}T12:00:00Z`).toLocaleDateString(lang === "es" ? "es-ES" : "en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function EventRow({ event, lang, ticketsLabel, archived = false }) {
  return (
    <div
      className={`grid grid-cols-1 items-center gap-3 border-b border-border py-7 sm:grid-cols-[160px_1fr_auto] ${archived ? "opacity-60" : ""}`}
      data-testid={`event-${event.id}`}
    >
      <span className="text-sm font-semibold uppercase tracking-widest text-terracotta">{eventDate(event.date, lang)}</span>
      <div>
        <p className="font-serif text-2xl text-charcoal sm:text-3xl">{event.title[lang]}</p>
        <p className="mt-1 text-sm text-charcoal/55">{event.venue[lang]} · {event.city[lang]}</p>
      </div>
      {event.ticketUrl ? (
        <a
          href={event.ticketUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`event-tickets-${event.id}`}
          className="inline-flex items-center gap-1.5 rounded-full border border-border px-5 py-2.5 text-sm font-semibold text-charcoal transition-colors hover:border-terracotta hover:text-terracotta"
        >
          {ticketsLabel} <ArrowUpRight className="h-4 w-4" />
        </a>
      ) : <span />}
    </div>
  );
}